import React from 'react'

const servicesData = [
  {
    title: 'Strategy and Consulting',
    description:
      'We transform your vision into technology roadmaps using expert guidance.',
  },
  {
    title: 'Custom Web & Salesforce Development',
    description:
      'From custom web applications to tailored Salesforce solutions, we build secure and scalable software that fits your exact operational needs.',
  },
  {
    title: 'Digital Transformation',
    description:
      'Modernize your operations with cloud solutions, automation, and cutting-edge technology.',
  },
  {
    title: 'AI Integration',
    description:
      'Unlock the power of Artificial Intelligence. We seamlessly integrate cutting-edge AI solutions to automate processes, generate insights, and drive intelligent growth.',
  },
]

const Services = () => {
  return (
    <section id="services" className="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {servicesData.map((service, index) => (
            <div className="service-card" key={index}>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services